/*
  Labyrinthine — player persistente + navigazione senza ricarica (Swup 4).
  Caricato come <script type="module"> in theme.liquid, dopo assets/swup.umd.js
  (Swup 4.10.0 salvato nel tema, espone window.Swup).
*/
const Swup = window.Swup;

const root = document.getElementById('lab-player');
const audio = root.querySelector('audio');
const $ = (s) => root.querySelector(s);
const ui = {
  link: $('.lab-player__link'),
  art: $('.lab-player__art'),
  title: $('.lab-player__title'),
  artist: $('.lab-player__artist'),
  seek: $('.lab-player__seek'),
  vol: $('.lab-player__vol'),
  cur: $('[data-lab-current]'),
  dur: $('[data-lab-duration]'),
};

let queue = [];   // [{ title, artist, url, art, href }]
let index = -1;
let seeking = false;

const fmt = (s) => {
  if (!isFinite(s)) return '0:00';
  const m = Math.floor(s / 60);
  return `${m}:${String(Math.floor(s % 60)).padStart(2, '0')}`;
};
const setState = (st) => { root.dataset.state = st; };
const setFill = (input) => {
  const pct = ((input.value - input.min) / (input.max - input.min)) * 100;
  input.style.setProperty('--lab-fill', `${pct}%`);
};

function load(i, autoplay = true) {
  if (i < 0 || i >= queue.length) return;
  index = i;
  const t = queue[i];
  audio.src = t.url;
  ui.title.textContent = t.title;
  ui.artist.textContent = t.artist || '';
  ui.link.href = t.href || '#';
  if (t.art) { ui.art.src = t.art; ui.art.hidden = false; } else { ui.art.hidden = true; }
  root.hidden = false;
  document.body.classList.add('lab-player-active');
  setState('loading');
  if (autoplay) audio.play().catch(() => setState('paused'));
  updateMediaSession(t);
  markCurrent();
  persist();
}

function toggle() {
  if (index < 0) return;
  audio.paused ? audio.play() : audio.pause();
}

function close() {
  audio.pause();
  audio.removeAttribute('src');
  audio.load();
  index = -1;
  setState('idle');
  document.body.classList.remove('lab-player-active');
  setTimeout(() => { if (root.dataset.state === 'idle') root.hidden = true; }, 400);
  markCurrent();
  try { sessionStorage.removeItem('lab-player'); } catch (e) {}
}

/* evidenzia la traccia in riproduzione nella tracklist visibile */
function markCurrent() {
  const url = index >= 0 ? queue[index].url : null;
  document.querySelectorAll('.lab-tracklist__item').forEach((li) => {
    li.classList.toggle('is-current', !!url && li.dataset.url === url);
  });
}

/* legge la tracklist di una release dal DOM */
function readTracklist(list) {
  const { artist, art, href } = list.dataset;
  return [...list.querySelectorAll('.lab-tracklist__item')].map((li) => ({
    title: li.dataset.title,
    url: li.dataset.url,
    artist, art, href,
  }));
}

/* ---- eventi audio ---- */
audio.addEventListener('playing', () => setState('playing'));
audio.addEventListener('pause', () => { if (index >= 0) setState('paused'); });
audio.addEventListener('waiting', () => setState('loading'));
audio.addEventListener('loadedmetadata', () => { ui.dur.textContent = fmt(audio.duration); });
audio.addEventListener('timeupdate', () => {
  if (seeking || !audio.duration) return;
  ui.seek.value = (audio.currentTime / audio.duration) * 1000;
  setFill(ui.seek);
  ui.cur.textContent = fmt(audio.currentTime);
});
audio.addEventListener('ended', () => {
  if (index < queue.length - 1) load(index + 1);
  else setState('paused');
});
audio.addEventListener('error', () => setState('paused'));

/* ---- controlli ---- */
root.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-lab-action]');
  if (!btn) return;
  const a = btn.dataset.labAction;
  if (a === 'toggle') toggle();
  if (a === 'next') load(index + 1);
  if (a === 'prev') audio.currentTime > 3 ? (audio.currentTime = 0) : load(index - 1);
  if (a === 'close') close();
});

ui.seek.addEventListener('input', () => {
  seeking = true;
  setFill(ui.seek);
  if (audio.duration) ui.cur.textContent = fmt((ui.seek.value / 1000) * audio.duration);
});
ui.seek.addEventListener('change', () => {
  if (audio.duration) audio.currentTime = (ui.seek.value / 1000) * audio.duration;
  seeking = false;
});

ui.vol.addEventListener('input', () => {
  audio.volume = ui.vol.value;
  setFill(ui.vol);
  try { localStorage.setItem('lab-vol', ui.vol.value); } catch (e) {}
});
try {
  const v = localStorage.getItem('lab-vol');
  if (v !== null) { ui.vol.value = v; audio.volume = v; }
} catch (e) {}
setFill(ui.vol);

/* spazio = play/pausa (fuori dai campi di testo) */
document.addEventListener('keydown', (e) => {
  if (e.code !== 'Space' || index < 0) return;
  if (e.target.closest('input, textarea, select, button, [contenteditable]')) return;
  e.preventDefault();
  toggle();
});

/* click sulla tracklist delle pagine release (delegato: funziona anche dopo le navigazioni Swup) */
document.addEventListener('click', (e) => {
  const trackBtn = e.target.closest('.lab-tracklist__btn');
  const allBtn = e.target.closest('.lab-tracklist__all');
  if (!trackBtn && !allBtn) return;
  const list = (trackBtn || allBtn).closest('[data-lab-release]').querySelector('.lab-tracklist');
  const tracks = readTracklist(list);
  const i = trackBtn ? [...list.children].indexOf(trackBtn.closest('li')) : 0;

  // stessa traccia già caricata → play/pausa
  if (index >= 0 && queue[index] && tracks[i] && queue[index].url === tracks[i].url) { toggle(); return; }
  queue = tracks;
  load(i);
});

/* ---- Media Session (controlli da lockscreen / tastiera multimediale) ---- */
function updateMediaSession(t) {
  if (!('mediaSession' in navigator)) return;
  navigator.mediaSession.metadata = new MediaMetadata({
    title: t.title, artist: t.artist || '', album: 'Labyrinthine',
    artwork: t.art ? [{ src: t.art, sizes: '512x512' }] : [],
  });
}
if ('mediaSession' in navigator) {
  navigator.mediaSession.setActionHandler('play', () => audio.play());
  navigator.mediaSession.setActionHandler('pause', () => audio.pause());
  navigator.mediaSession.setActionHandler('previoustrack', () => load(index - 1));
  navigator.mediaSession.setActionHandler('nexttrack', () => load(index + 1));
}

/* ---- pulsante Chat di Shopify Inbox: lo alza sopra il player ----
   Vive in uno shadow DOM che il CSS del tema non raggiunge: si aggiunge una regola
   che usa --lab-chat-offset (impostata su body.lab-player-active in lab-player.css).
   La chat si carica in ritardo, quindi si riprova per un minuto. */
let chatTries = 0;
const chatTimer = setInterval(() => {
  const rt = document.querySelector('shopify-chat')?.shadowRoot
    ?.querySelector('shopify-agent-runtime')?.shadowRoot;
  if (rt && !rt.getElementById('lab-chat-offset')) {
    const st = document.createElement('style');
    st.id = 'lab-chat-offset';
    st.textContent = '.activator-nudge { bottom: calc(20px + var(--lab-chat-offset, 0px)) !important; transition: bottom .35s ease; }';
    rt.appendChild(st);
  }
  if (rt || ++chatTries > 60) clearInterval(chatTimer);
}, 1000);

/* ---- ripristino dopo un ricaricamento vero (es. ritorno dal checkout) ---- */
function persist() {
  try { sessionStorage.setItem('lab-player', JSON.stringify({ queue, index })); } catch (e) {}
}
try {
  const saved = JSON.parse(sessionStorage.getItem('lab-player') || 'null');
  if (saved && saved.queue && saved.queue.length) {
    queue = saved.queue;
    load(saved.index, false);   // carica in pausa: il browser blocca l'autoplay
    setState('paused');
  }
} catch (e) {}

/* ---- navigazione senza ricarica ---- */
const swup = new Swup({
  containers: ['#MainContent'],
  ignoreVisit: (url, { el } = {}) => {
    if (el && el.closest('[data-no-swup]')) return true;
    const path = new URL(url, location.origin).pathname;
    // pagine che devono ricaricarsi per davvero
    return /^\/(cart|account|checkout|challenge|password|admin)/.test(path)
        || /\/(cart|account)(\/|$)/.test(path); // anche con prefisso lingua, es. /en/cart
  },
});

/* i template delle app (Single, ecc.) hanno script inline propri: lì si ricarica davvero */
let reloading = false;
swup.hooks.on('page:load', (visit, { page }) => {
  const doc = new DOMParser().parseFromString(page.html, 'text/html');
  if (doc.querySelector('#MainContent[data-lab-reload]')) {
    reloading = true;
    visit.abort();
    location.assign(visit.to.url);
  }
});

/* esegue gli script della nuova pagina, ma non quelli di Dawn già caricati:
   rieseguirli darebbe "already defined" e romperebbe carrello e menu */
const loadedSrc = new Set([...document.scripts].map((s) => s.src).filter(Boolean));
const isJs = (s) => !s.type || /^(module|(text|application)\/(java|ecma)script)$/i.test(s.type);
swup.hooks.on('content:replace', () => {
  if (reloading) return;
  document.querySelectorAll('#MainContent script').forEach((old) => {
    if (!isJs(old)) return;
    if (old.src) {
      if (loadedSrc.has(old.src)) return;
      loadedSrc.add(old.src);
    }
    const s = document.createElement('script');
    for (const a of old.attributes) s.setAttribute(a.name, a.value);
    if (old.src) s.async = false;
    else s.textContent = old.textContent;
    old.replaceWith(s);
  });
});

swup.hooks.on('page:view', () => {
  markCurrent();
  // chiude menu e ricerca dell'header di Dawn dopo il cambio pagina
  document.querySelectorAll('.header-wrapper details[open]').forEach((d) => {
    d.removeAttribute('open');
    d.classList.remove('menu-opening');
  });
  document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet');
});

markCurrent();
